import { Box, GlobalStyles, Grid, Typography } from "@mui/material";
import { useContext, useState } from "react";
import { WindowSizeContext } from "../../../common/context/WindowSizeContext";
import Back from "../../../common/components/BackNavigateComponent";
import DashboardLevelFilters from "./Filters/DashboardLevelFilters";
import DashboardMetaProvider from "../common/providers/DashboardMetaProvider";
import SelectorProvider, { useSelectorContext, useSelectorState, useSelectorValue } from "../common/providers/selectorProvider";
import { dashboardDefinitions } from "./dashboardDefinitions";
import AsOfDate from "./AsOfDate";
import InfoToolTip from "./Component/InfoToolTip";
import FreshHourlyOOSTableComponent from "./OOSTable";
import { TABLE_FRESH_HOURLY_OOS, TABLE_FRESH_HOURLY_OOS_L30D, TABLE_FRESH_HOURLY_OOS_L7D, TABLE_FRESH_HOURLY_OOS_YTD } from "./constant";
import { registerDashboard } from "../../../common/utils";

registerDashboard(dashboardDefinitions)

export default function FreshHourlyOOS({ title = "Fresh Hourly Out-of-Stock" }) {
    const windowSize = useContext(WindowSizeContext);
    const [isFiltersOpen, setFiltersOpen] = useState(false);
    // const days = useSelectorValue('days')
    const [filters, setFilters] = useState()

    // let tableName;
    // switch (days) {
    //     case '7':
    //         tableName = TABLE_FRESH_HOURLY_OOS_L7D;
    //         break;
    //     case '30':
    //         tableName = TABLE_FRESH_HOURLY_OOS_L30D;
    //         break;
    //     case 'ytd':
    //         tableName = TABLE_FRESH_HOURLY_OOS_YTD;
    //         break;
    //     case '3':
    //     default:
    //         tableName = TABLE_FRESH_HOURLY_OOS;
    // }

    return <>
        <DashboardMetaProvider dashboardDefinition={dashboardDefinitions}>
            <SelectorProvider
                defaults={{
                    'company_id': [7, 2, 142],
                    'days': "3",
                    'region': "select-all",
                    'store': "select-all",
                    'category': "Imported Fruits",
                    // 'topSKU': ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20'],

                    'initial_company': [7, 2, 142],
                    'initial_days': "3",
                    'initial_region': "select-all",
                    'initial_store': "select-all",
                    'initial_category': "Imported Fruits",
                    // 'initial_topSKU': ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20'],
                }}
            >
                <GlobalStyles styles={{ body: { backgroundColor: '#e0e0e0' } }} />

                <Grid container xs={12}>
                    <Grid item xs={12} sx={{ display: !windowSize.isOnMobile && "flex", justifyContent: "space-between", alignItems: "center", my: 2 }}>
                        <Grid item xs display={'flex'} sx={{ alignItems: 'center' }}>
                            <Back />
                            <Typography variant="h5" ml={3}>
                                {title}
                            </Typography>
                            <InfoToolTip component={'dashboard'} />
                        </Grid>
                        <Grid item xs justifyContent={'flex-end'} display={'flex'}>
                            <AsOfDate tableName={TABLE_FRESH_HOURLY_OOS} />
                        </Grid>
                    </Grid>
                    {/* <DashboardLevelFilters
                        isOpen={isFiltersOpen}
                        setIsOpen={setFiltersOpen}
                        tableName={TABLE_FRESH_HOURLY_OOS}
                        filters={filters}
                        setFilters={setFilters}
                    /> */}
                </Grid>
                <FreshHourlyOOSTableComponent tableName={TABLE_FRESH_HOURLY_OOS} filter={filters} isOpen={isFiltersOpen}
                    setIsOpen={setFiltersOpen} />

            </SelectorProvider>
        </DashboardMetaProvider>

    </>
}